function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M426.40942,552.324a22.04855,22.04855,0,0,0-.4502,31.02539L565.33959,727.60722a21.99984,21.99984,0,0,0,31.34375.30274l425.31153-423.46924a22.00169,22.00169,0,0,0-3.5166-34.02442L851.23706,161.4871a21.87128,21.87128,0,0,0-27.37793,2.69483Z",
  transform: "translate(-171.52722 -151.90994)",
  fill: "#3f3d56"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1024.91107,276.8491a22.14312,22.14312,0,0,1-2.9162,3.59162L597.68334,711.91a21.99984,21.99984,0,0,1-31.34375-.30274L423.95922,561.34941a21.90749,21.90749,0,0,1-2.60186-3.28082c-5.46,8.40026-2.6363,17.79016,4.60186,25.28082L565.33959,727.60722a21.99984,21.99984,0,0,0,31.34375.30274l425.31153-423.46924a22.00776,22.00776,0,0,0,2.9162-27.59162Z",
  transform: "translate(-171.52722 -151.90994)",
  fill: "#c4b581"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M985.53161,282.06822,968.224,271.03312a16.49049,16.49049,0,0,1-23.734,21.65174l-112-77a16.48044,16.48044,0,0,1,4.35736-29.30127l-8.917-5.6853a6,6,0,0,0-7.49359.84191L443.6607,551.80906a6,6,0,0,0,.15186,8.58277L580.64843,693.72288a6.00008,6.00008,0,0,0,8.35175-.116L986.54162,291.377A6,6,0,0,0,985.53161,282.06822Z",
  transform: "translate(-171.52722 -151.90994)",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  points: "379.147 318.14 494.73 427.118 769.652 155.498 630.127 64.683 379.147 318.14",
  fill: "#e6e6e6"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M930.49389,374.44169a4.09726,4.09726,0,0,0,5.65723,0l24.042-24.0415a4.00623,4.00623,0,0,0,0-5.65674,4.09728,4.09728,0,0,0-5.65723,0l-24.042,24.04151a4.00622,4.00622,0,0,0,0,5.65673Z",
  transform: "translate(-171.52722 -151.90994)",
  fill: "#3f3d56"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M889.99389,414.94218a4.0068,4.0068,0,0,0,5.65723,0l24.042-24.042a4.00027,4.00027,0,0,0-5.65723-5.65723l-24.042,24.042A4.00592,4.00592,0,0,0,889.99389,414.94218Z",
  transform: "translate(-171.52722 -151.90994)",
  fill: "#3f3d56"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 381.81629,
  cy: 411.68263,
  r: 27,
  fill: "#c4b581"
});

var _ref9 = /*#__PURE__*/React.createElement("polygon", {
  points: "643.194 584.088 69.113 584.088 69.113 581.907 643.589 581.907 643.194 584.088",
  fill: "#3f3d56"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 293.40678,
  y: 178.37191,
  width: 285.40951,
  height: 56.35009,
  fill: "#e6e6e6"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 293.40678,
  y: 89.33251,
  width: 285.40951,
  height: 56.35007,
  fill: "#e6e6e6"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 293.40678,
  width: 285.40951,
  height: 56.35007,
  fill: "#e6e6e6"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M471.01835,202.17538h273.2409V157.99444H471.01835Z",
  transform: "translate(-171.52722 -151.90994)",
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M471.01835,291.70442h273.2409V247.52348H471.01835Z",
  transform: "translate(-171.52722 -151.90994)",
  fill: "#fff"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M471.0183,380.54737H744.2592V336.36643H471.0183Z",
  transform: "translate(-171.52722 -151.90994)",
  fill: "#fff"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 323.41136,
  cy: 27.80913,
  r: 16.83183,
  fill: "#c4b581"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 363.66141,
  y: 21.22276,
  width: 166.12293,
  height: 3.6591,
  fill: "#c4b581"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 363.66141,
  y: 30.7364,
  width: 166.12293,
  height: 3.6591,
  fill: "#c4b581"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 323.41136,
  cy: 117.87345,
  r: 16.83183,
  fill: "#ccc"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 363.66141,
  y: 111.28708,
  width: 166.12293,
  height: 3.6591,
  fill: "#ccc"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 363.66141,
  y: 120.80073,
  width: 166.12293,
  height: 3.6591,
  fill: "#ccc"
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 323.41136,
  cy: 206.91288,
  r: 16.83184,
  fill: "#ccc"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 363.66141,
  y: 200.3265,
  width: 166.12293,
  height: 3.6591,
  fill: "#ccc"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 363.66141,
  y: 209.84016,
  width: 166.12293,
  height: 3.6591,
  fill: "#ccc"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M184.32957,742.63385l7.36292.86469c5.81584,3.50649,12.642,4.82649,20.20218,4.55779a6.05846,6.05846,0,0,0,5.132-3.145h0a6.004,6.004,0,0,0-3.91692-8.70765l-5.59465-1.3031L194.0152,721.69722,185.871,706.95763l-11.8301,1.35673-2.46277,18.722h0A14.49193,14.49193,0,0,0,184.32957,742.63385Z",
  transform: "translate(-171.52722 -151.90994)",
  fill: "#2f2e41"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M299.00376,733.16205l7.21645,1.698c5.37845,4.1463,12.00973,6.23546,19.55131,6.8299a6.05842,6.05842,0,0,0,5.45694-2.53975h0a6.004,6.004,0,0,0-2.89929-9.09723l-5.40974-1.93205-11.90765-14.65557L304.6,697.89378H292.69233l-4.57986,18.31946v0A14.49193,14.49193,0,0,0,299.00376,733.16205Z",
  transform: "translate(-171.52722 -151.90994)",
  fill: "#2f2e41"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M304.91972,698.92961l-13.46579,2.07166-21.23451-107.2084-36.772-62.66772L188.90676,713.43123l-16.57328,3.10749c1.85841-102.66356-7.21224-231.91221,13.46579-247.56337l90.11721,10.3583L315.278,584.98831Z",
  transform: "translate(-171.52722 -151.90994)",
  fill: "#2f2e41"
});

var _ref28 = /*#__PURE__*/React.createElement("circle", {
  cx: 68.13521,
  cy: 126.47269,
  r: 31.0749,
  fill: "#ffb8b8"
});

var _ref29 = /*#__PURE__*/React.createElement("polygon", {
  points: "24.63 174.121 61.92 180.336 71.243 147.189 44.311 138.903 24.63 174.121",
  fill: "#ffb8b8"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M180.62012,473.11867l99.43968,9.32247c-7.972-27.7204-15.276-55.34331-9.32247-82.8664,7.56022-24.57156.26307-39.18354-19.68077-50.75567L237.59077,318.78l-36.254-4.14332,0,0a78.25621,78.25621,0,0,0-11.10752,51.75006C195.395,405.565,194,441.9202,180.62012,473.11867Z",
  transform: "translate(-171.52722 -151.90994)",
  fill: "#c4b581"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M227.443,243.11641c10.61287-.73316,22.88326-.93545,24.41984,1.85991,10.98982-.514,20.56107,3.31964,24.97579,12.24077a5.8793,5.8793,0,0,1-3.67285,8.23332c-5.5751,1.60739-14.07279,3.5959-20.273,2.9609-12.87684,15.13891-7.45891,42.75067,5.04,58.88174l-11.29454,2.31512L225.206,299.76156l6.76274,32.85356-26.08152,4.26594-9.09667-41.75119a63.46521,63.46521,0,0,1,1.39631-29.82229,23.96664,23.96664,0,0,1,1.092-2.86817A33.29988,33.29988,0,0,1,227.443,243.11641Z",
  transform: "translate(-171.52722 -151.90994)",
  fill: "#2f2e41"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M244.84158,504.19357l-.68708,24.048a13.11172,13.11172,0,0,0,11.8017,13.42112h0a13.11172,13.11172,0,0,0,13.96224-16.46761l-5.39612-19.96566L248.9849,420.29134l1.03583-49.71984-33.14656-1.03583,6.215,55.93482Z",
  transform: "translate(-171.52722 -151.90994)",
  fill: "#ffb8b8"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M214.80251,374.71482a52.381,52.381,0,0,1,37.28988,0l-2.07166-41.43321a16.57327,16.57327,0,0,0-16.57326-16.57327h0a16.57327,16.57327,0,0,0-16.57326,16.57327Z",
  transform: "translate(-171.52722 -151.90994)",
  fill: "#c4b581"
});

var SvgNotifiysvg = function SvgNotifiysvg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a3f5ff23-4296-4538-8667-ded3127d147a",
    "data-name": "Layer 1",
    width: 856.94557,
    height: 596.18012,
    viewBox: "0 0 856.94557 596.18012",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotifiysvg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notifiysvg.e7d16fcf.svg";
export { ForwardRef as ReactComponent };